module.exports = require("./zh-Hant-HK");